import React from "react";
import { Button } from "../ui/button";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "../ui/dialog";
import { Input } from "../ui/input";
import { Loader2 } from "lucide-react";
import { Textarea } from "../ui/textarea";

export default function RejectDialog({ reject, rejectName, rejectOpen, rejectReason, rejecting, setRejectName, setRejectOpen, setRejectReason }) {
  return (
    <Dialog open={rejectOpen} onOpenChange={setRejectOpen}>
      <DialogContent data-testid="public-reject-dialog">
        <DialogHeader>
          <DialogTitle>Rifiuta il preventivo</DialogTitle>
          <DialogDescription>
            Facci sapere il motivo (facoltativo): aiuterà l'emittente a proporti un'alternativa.
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-3">
          <Input
            data-testid="public-reject-name-input"
            placeholder="Nome e Cognome (facoltativo)"
            value={rejectName}
            onChange={(e) => setRejectName(e.target.value)}
          />
          <Textarea
            data-testid="public-reject-reason-input"
            placeholder="Motivo del rifiuto…"
            rows={4}
            value={rejectReason}
            onChange={(e) => setRejectReason(e.target.value)}
          />
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => setRejectOpen(false)}>
            Annulla
          </Button>
          <Button
            data-testid="public-reject-submit-button"
            onClick={reject}
            disabled={rejecting}
            className="bg-red-600 hover:bg-red-700"
          >
            {rejecting ? <Loader2 className="w-4 h-4 animate-spin" /> : "Conferma Rifiuto"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
